import React, { RefObject, useState } from "react";
import clsx from "clsx";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../../styles/theme";
import off from "../../assets/off2@2x.png";
import on from "../../assets/on2@2x.png";
import right from "../../assets/rightArrow@2x.png";
import notice from "../../assets/06IconIi@2x.png";

interface Props {
   checked: boolean;
   setChecked: (checked: boolean) => void;
   goTo: (e: any, url: string) => void;
   btnRef: RefObject<HTMLButtonElement>;
   onClick: () => void;
}

const OnboardAgrContent10602: React.FC<Props> = ({
   checked,
   setChecked,
   goTo,
   btnRef,
   onClick,
}) => {
   const classes = useStyles();

   return (
      <>
         <div className={clsx("container", classes.container)}>
            <div>
               <h1 className={classes.h1}>
                  쯩 서비스 이용에는 <br />
                  사용자 동의가 필요합니다.
               </h1>

               <div
                  className={classes.checkboxAll}
                  onClick={(e) => {
                     e.preventDefault();
                     setChecked(!checked);
                  }}
               >
                  <input
                     className={clsx(classes.checkbox, checked && "checked")}
                     id="agreementAll"
                     type="checkbox"
                     checked={checked}
                     readOnly
                  />
                  <label htmlFor="agreementAll"></label>
                  <span>모두 동의합니다.</span>
                  <span>[필수]</span>
               </div>
               <ul className={classes.list}>
                  <li onClick={(e) => goTo(e, "/agr/tos/0")}>
                     <div className={classes.flex}>
                        <span>서비스 이용 약관에 동의합니다.</span>
                     </div>
                     <span className={classes.view_more}></span>
                  </li>
                  <li onClick={(e) => goTo(e, "/agr/tos/8")}>
                     <div className={classes.flex}>
                        <span>개인정보 수집 및 이용에 동의합니다.</span>
                     </div>
                     <span className={classes.view_more}></span>
                  </li>
                  <li onClick={(e) => goTo(e, "/agr/tos/9")}>
                     <div className={classes.flex}>
                        <span>고유식별정보 처리를 동의합니다.</span>
                     </div>
                     <span className={classes.view_more}></span>
                  </li>
               </ul>
            </div>
            <div className={classes.caption}>
               <div className={clsx(classes.guide, "mgb_14")}>
                  개인정보는 본인확인 후 사용자의 단말에만 저장되며 쯩에서는
                  저장하지 않고 즉시 파기됩니다.
               </div>
               <div className={classes.guide}>
                  14세 미만인 경우 휴대폰 본인확인 후 보호자의 휴대폰 본인확인과
                  동의가 필요합니다.
               </div>
            </div>
         </div>
         <div className={classes.float}>
            <button
               ref={btnRef}
               disabled={!checked}
               className={classes.button}
               onClick={onClick}
            >
               휴대폰 본인확인을 시작합니다
            </button>
         </div>
      </>
   );
};

const useStyles = createUseStyles((theme: ThemeType) => ({
   container: {
      width: "100vw",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: "60px 0 7.4rem 0 !important",
      overflow: "scroll",
      "& > div:first-of-type": {
         padding: "0 20px 20px 20px",
      },
      "& > img": {
         width: 46,
         height: 46,
         marginBottom: 14,
      },
   },
   h1: {
      fontSize: "2.6rem",
      color: theme.mono0,
      marginBottom: 26,
      lineHeight: "3.6rem",
      letterSpacing: "-0.05px",
      fontWeight: theme.demiLight,
   },
   text: {
      fontSize: "1.4rem",
      color: theme.mono50,
      lineHeight: "2.2rem",
      fontWeight: theme.demiLight,
   },
   checkboxAll: {
      width: "100%",
      padding: "21px 16px",
      boxShadow: "0px 3px 16px 0px rgba(0,0,0,0.08)",
      borderRadius: 10,
      lineHeight: "2.8rem",
      display: "flex",
      "& > span": {
         fontSize: "1.6rem",
         color: theme.mono0,
         lineHeight: "2.6rem",
         letterSpacing: "-0.02rem",
      },
      "& > span:first-of-type": {
         marginRight: 3,
      },
      "& > span:last-of-type": {
         fontWeight: theme.medium,
         color: theme.primaryTxt,
      },
   },
   checkbox: {
      display: "none",
      "& + label": {
         paddingLeft: 16,
         marginRight: 10,
         width: 22,
         height: 22,
         background: `url(${off}) center center no-repeat`,
         backgroundSize: "100% auto",
         marginTop: 1,
         verticalAlign: "baseline",
      },
      "&.checked + label": {
         background: `url(${on}) center center no-repeat`,
         backgroundSize: "100% auto",
      },
   },
   list: {
      paddingLeft: `16px!important`,
      "& li": {
         "&:first-of-type": {
            marginTop: 26,
         },
         margin: "20px 8px 0 0",
         display: "flex",
         justifyContent: "space-between",
         height: 23,
         color: theme.mono50,
      },
   },
   flex: {
      display: "flex",
      wordBreak: "keep-all",
      "& > span": {
         fontSize: "1.4rem",
         fontWeight: theme.demiLight,
         lineHeight: "2.2rem",
         letterSpacing: "-0.02px",
         "& span.primary": {
            marginLeft: 3,
            fontWeight: theme.medium,
            color: theme.primaryTxt,
         },
      },
   },
   view_more: {
      width: 28,
      height: 28,
      background: `url(${right}) right center no-repeat`,
      backgroundSize: "28px auto",
   },
   float: {
      position: "fixed",
      bottom: 0,
      width: "100%",
      padding: 20,
      backgroundColor: "#FFF",
   },
   button: {
      width: "100%",
      fontSize: "1.8rem",
      background: theme.primarySol,
      height: 54,
      color: theme.mono100,
      padding: "13px 20px",
      fontWeight: theme.regular,
      borderRadius: 6,
      "&:disabled": {
         background: theme.monoDivider,
         color: theme.mono50,
      },
   },
   caption: {
      padding: 20,
      marginBottom: 20,
      background: theme.monoBg,
   },
   guide: {
      fontSize: "1.4rem",
      lineHeight: "2.2rem",
      color: theme.mono50,
      paddingLeft: 22,
      background: `url(${notice}) left 0px top 5px no-repeat`,
      backgroundSize: "16px 16px",
      "&.mgb_14": {
         marginBottom: 14,
      },
   },
}));

export default OnboardAgrContent10602;
